import TextCell from 'components/TextCell';
import type { ManagedOemSegmentType } from '../..';

interface CellProps {
  rowData: ManagedOemSegmentType;
}

export default function FleetsCountCell({ rowData: { totals } }: CellProps) {
  return <TextCell text={String(totals?.fleets)} />;
}
